import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class ReviseTranscriptTurn {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly turnId: number,
		public readonly text: string,
	) {
		Object.freeze(this);
	}

	// Route identifiers are never echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			text: this.text,
		};
	}
}

export default ReviseTranscriptTurn;
